/* EL PUENTE DE LA BOLSA A WHATSAPP · 28-ago-2026
 * El porqué está en `snippets/avora-wa-bolsa.liquid`.
 *
 * 🔴 ESTE ARCHIVO NO CREA EL ENLACE, LO REFRESCA. El enlace ya viene armado
 * desde el servidor con la bolsa tal como estaba al cargar la página. Aquí sólo
 * se vuelve a escribir cuando la clienta cambia una cantidad o quita una prenda
 * sin recargar — que es justo lo que hacen el cajón y la página de la bolsa.
 * Si este script no corre, el botón sigue funcionando; nada más manda la lista
 * de hace un momento. Un enlace viejo es recuperable en la conversación; un
 * botón muerto no.
 *
 * 🔴 EL PRECIO VIENE EN CENTAVOS. `/cart.js` devuelve `line_price: 39000` para
 * $390 — el mismo tropiezo que ya está anotado en `avora-cajon.js`.
 */
(function () {
  if (typeof fetch !== 'function') return;

  var botones = document.querySelectorAll('[data-wa-bolsa]');
  if (!botones.length) return;

  /* 🔴 EL FORMATO DE MONEDA LO DICE LA TIENDA, NO `Intl`. Medido el 28-ago:
     esta tienda tiene `money_format` = "$ {{amount}}" —con espacio— y
     `Intl.NumberFormat('es-MX')` devuelve "$799.20" —sin espacio—. El resultado
     era que el mismo mensaje mostraba "$ 1,998.00" en las líneas que pintó el
     servidor y "$799.20" en la cifra que recalculó el navegador: dos formas de
     escribir dinero en una pantalla donde la clienta va a transferir. El
     formato viaja en el botón desde Liquid, así que sigue a la tienda si algún
     día cambia de moneda o de separadores. */
  /* Se busca en cada pasada, no una vez al arrancar: este archivo puede
     ejecutarse antes de que el cajón esté en el DOM, y una constante leída
     demasiado pronto se habría quedado con el formato de reserva para siempre. */
  function formato() {
    var n = document.querySelector('[data-money]');
    return (n && n.getAttribute('data-money')) || '$ {{amount}}';
  }

  function miles(n, milesSep, decSep, decimales) {
    var f = n.toFixed(decimales);
    var partes = f.split('.');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, milesSep);
    return decimales ? partes.join(decSep) : partes[0];
  }

  function pesos(centavos) {
    var v = (centavos || 0) / 100;
    /* Los cuatro marcadores que Shopify admite. El que no aparezca en el
       formato de esta tienda simplemente no se sustituye. */
    return formato()
      .replace('{{amount_no_decimals_with_comma_separator}}', miles(v, '.', ',', 0))
      .replace('{{amount_with_comma_separator}}',             miles(v, '.', ',', 2))
      .replace('{{amount_no_decimals}}',                      miles(v, ',', '.', 0))
      .replace('{{amount}}',                                  miles(v, ',', '.', 2));
  }

  /* El porcentaje del apartado lo declara el Liquid en el propio botón. No se
     cablea aquí un 40 a mano: el día que Priscila lo mueva en Configuración del
     tema, el mensaje y el renglón de abajo cambiarían solos pero este archivo
     seguiría diciendo el número viejo, y serían dos cifras distintas en la
     misma pantalla. Sin el atributo, no hay apartado y no se menciona. */
  function pctApartado() {
    var b = document.querySelector('[data-wa-bolsa][data-ap-pct]');
    if (!b) return 0;
    var n = parseInt(b.getAttribute('data-ap-pct'), 10);
    return isNaN(n) ? 0 : n;
  }

  function arma(carrito) {
    var lineas = (carrito.items || []).map(function (it, i) {
      /* `variant_title` sale null cuando la prenda no tiene opciones, y
         'Default Title' cuando tiene una opción sin nombrar. Ninguna de las dos
         se le escribe a nadie. */
      var talla = it.variant_title && it.variant_title.indexOf('Default') === -1
        ? ' — talla ' + it.variant_title : '';
      var cuantas = it.quantity > 1 ? ' ×' + it.quantity : '';
      return (i + 1) + '. ' + it.product_title + talla + cuantas + ' — ' + pesos(it.line_price);
    });
    if (!lineas.length) return null;

    var pct = pctApartado();
    var anticipo = '';
    if (pct > 0) {
      /* Se redondea hacia ABAJO, igual que `divided_by` de Liquid, que trunca.
         Con Math.round el servidor y el navegador podían diferir en un centavo
         y la clienta vería una cifra al cargar y otra al mover una cantidad. */
      anticipo = pesos(Math.floor((carrito.total_price || 0) * pct / 100));
      [].slice.call(document.querySelectorAll('[data-ap-cifra]')).forEach(function (n) {
        n.textContent = anticipo;
      });
    }

    return 'Hola, quiero apartar estas piezas:\n\n' + lineas.join('\n') +
           '\n\nTotal: ' + pesos(carrito.total_price) +
           (anticipo ? '\nPara apartarlas (' + pct + '%): ' + anticipo : '') +
           '\n' + location.origin;
  }

  function escribe(texto) {
    if (!texto) return;                          /* bolsa vacía: no se toca nada */
    /* Se vuelven a buscar en cada pasada: el cajón repinta su pie y el botón
       puede ser un nodo distinto del que había al arrancar. */
    [].slice.call(document.querySelectorAll('[data-wa-bolsa]')).forEach(function (b) {
      var num = b.getAttribute('data-wa-num');
      if (!num) return;
      b.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(texto);
    });
  }

  function refresca() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) { escribe(arma(carrito)); })
      .catch(function () { /* se queda el enlace del servidor */ });
  }

  function conCarrito(e) {
    /* El cajón manda la bolsa ya leída en `detail`: se aprovecha y se ahorra
       una segunda ida a `/cart.js` por cada toque en «+». */
    if (e && e.detail && e.detail.items) { escribe(arma(e.detail)); return; }
    refresca();
  }

  /* Dos avisos distintos y los dos hacen falta:
       · `avora:bolsa`         — algo se agregó desde fuera (vista rápida, ficha)
       · `avora:bolsa-pintada` — el cajón acaba de repintar tras un +/- o un quitar
     Sin el segundo, cambiar una cantidad dentro del cajón dejaba el mensaje con
     la cantidad vieja. */
  document.addEventListener('avora:bolsa', refresca);
  document.addEventListener('avora:bolsa-pintada', conCarrito);

  /* Y una lectura al cargar: se pudo haber agregado algo desde otra pestaña. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresca);
  } else {
    refresca();
  }
})();
